export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-background-200 text-foreground-800">
      <div className="container-x py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <a href="#home" className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-ink-bottle-line text-lg"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">同人本子</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed max-w-sm text-foreground-600">
              同人本子官网提供高清原图与扫描画集在线浏览，涵盖热门作品同人插画与成套图包，画质清晰、分类细致，适合收藏与参考，更新迅速。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {[
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-bilibili-line", label: "B站" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-mail-line", label: "邮箱" },
              ].map((item) => (
                <a
                  key={item.label}
                  href="#home"
                  aria-label={item.label}
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50 border border-background-300 text-foreground-700 hover:text-primary-600 hover:border-primary-300 transition-colors"
                >
                  <i className={item.icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base text-foreground-950">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { id: "hot", label: "热门推荐" },
                { id: "category", label: "作品分类" },
                { id: "gallery", label: "在线浏览" },
                { id: "updates", label: "更新资讯" },
              ].map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-foreground-950">帮助与支持</h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { id: "faq", label: "常见问题" },
                { id: "about", label: "关于我们" },
                { id: "home", label: "回到首页" },
              ].map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {year} 同人本子官网 · 仅供个人学习交流与欣赏
          </p>
          <p className="text-xs text-foreground-500">
            <i className="ri-heart-3-line text-primary-500"></i> 用心整理每一份同人创作
          </p>
        </div>
      </div>
    </footer>
  );
}